enum UserSourceDialogFields {
	TYPE = "type",
	URL = "url",
	ANONYMOUS = "anonymous",
	USER = "user",
	PASSWORD = "password",
	USER_BASE = "user_base",
	USER_SEARCH = "user_search",
	GROUPS_BASE = "groups_base",
	GROUPS_SEARCH = "groups_search",
	GROUPS_FIELD = "groups_field",
	GROUPS_USER = "groups_user",
	GROUPS_ADMIN = "groups_admin",
	ATTRIBUTE_CERTIFICATE = "attribute_certificate",
	AZURE_CLIENT_ID = "azure_client_id",
	AZURE_USER_ROLE = "azure_user_role",
	AZURE_ADMIN_ROLE = "azure_admin_role",
	AZURE_AUTHORITY = "azure_authority",
	AZURE_SCOPE = "azure_scope",
	USER_PKCS12 = "user_pkcs12",
	FOLLOW_REFERRAL = "follow_referral",
	TRUSTMODE = "trustmode"
}

export default UserSourceDialogFields;